import React from "react";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

export const Settings = () => {
    const title = 'Tutoriel Sherlook';

    return (
        <Card sx={{ maxWidth: 800, margin: 'auto', mt: 5 }}>
        <CardContent>
          <Typography variant="h6" component="div">
            {title}
          </Typography>
        </CardContent>
      </Card>
    )
}